
import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';

const ContactInfoCards: React.FC = () => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];

  const contactItems = [
    {
      icon: <Mail className="w-6 h-6" />,
      title: t.email || 'Email',
      value: 'info@future-level.ch',
      action: 'mailto:info@future-level.ch',
      color: 'from-purple-600 to-blue-500'
    },
    {
      icon: <Phone className="w-6 h-6" />,
      title: t.phone || 'Phone',
      value: '+41 41 539 16 13',
      action: 'tel:+41415391613',
      color: 'from-cyan-500 to-blue-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
      {contactItems.map((item, index) => (
        <a 
          href={item.action} 
          key={index} 
          className="group relative overflow-hidden rounded-xl bg-gray-900/70 backdrop-blur-sm border border-gray-800 p-6 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/10 hover:-translate-y-1"
          target={item.action.startsWith('http') ? '_blank' : undefined}
          rel="noopener noreferrer"
        >
          <div className="flex flex-col items-center justify-center text-center">
            <div className={`flex items-center justify-center w-14 h-14 rounded-full mb-4 bg-gradient-to-br ${item.color} shadow-lg transition-transform duration-300 group-hover:scale-110`}>
              {React.cloneElement(item.icon, { className: "w-6 h-6 text-white" })}
            </div>
            <h3 className="text-lg font-semibold text-gray-100 mb-2">{item.title}</h3>
            <p className="text-gray-300">{item.value}</p>
          </div>
          
          {/* Background Elements */}
          <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-b from-purple-500/5 to-transparent rounded-bl-full -z-10"></div>
          <div className="absolute bottom-0 left-0 w-16 h-16 bg-gradient-to-t from-blue-500/5 to-transparent rounded-tr-full -z-10"></div>
          
          {/* Hover Effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-purple-600/10 to-blue-600/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
        </a>
      ))}
    </div>
  );
};

export default ContactInfoCards;
